export default "__VITE_ASSET__BcD4hSXB__"